import { CreditNoteAPI } from "../api";
import { DocumentItem } from "./DocumentItem.class";
import Helper from "../plugins/Helper/Helper";
import Vue from "vue";
export class CreditNote {
  constructor(props) {
    this.isCreditNote = true
    this.objectId = props.objectId;
    this.createdAt = props.createdAt;
    this.isVatInclusive = props.isVatInclusive || false;
    this.project = props.project;
    this.market = props.market;
    this.contract = props.contract;
    this.createdBy = props.createdBy;
    this.runningNumber = props.runningNumber;
    this.documentId = props.documentId;
    this.date = props.date ? props.date.iso : null;
    this.dueDate = props.dueDate ? props.dueDate.iso : null;
    this.note = props.note;
    this.vatPercent = props.vatPercent || Vue.prototype.$globalVatPercent || 7
    this.isSent = props.isSent || false;
    this.isPaid = props.isPaid || false;
    this.isVat = props.isVat;
    this.objected = props.objected;
    this.invoice = props.invoice;
    this.marketName = this.market ? this.market.name : ''
    this.contractCheckOut = props.contractCheckOut
    this.businessName = ""
    this.currencyCode = props.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
    if (this.invoice) {
      this.customerData = this.invoice.customerData
      this.invoiceId = this.invoice.documentId
    }
    if(this.contractCheckOut){
      if(this.contractCheckOut.depositInvoices && this.contractCheckOut.depositInvoices.length){
        this.contractCheckOutInvoice = this.contractCheckOut.depositInvoices.find(i=>i.id == this.invoice.objectId)
      }
      this.contractCheckoutId = this.contractCheckOut.documentId

      this.businessName = this.contractCheckOut.contract.businessName ?  this.contractCheckOut.contract.businessName  : '';
    }
    this.contractCustomerMarketId = this.contract && this.contract.customerMarketId ? this.contract.customerMarketId : '-'
    this.tels = [""];
    this.emails = [""];
    if (this.customerData) {
      this.tels = this.customerData?.tel?.split(",");
      this.emails = this.customerData?.email?.split(",");
      this.customerDataName = this.customerData.name
    }

    const items = props.items?.filter(d => {
      const area = d.area ? d.area : { isRemove: true, name: "-" };
      d.area = area;
      return d;
    });
    this.items = [];
    this.areaName = "-"
    if (items && items.length) {
      let name = [];
      for (let item of items) {
        this.items.push(
          new DocumentItem(
            item,
            this.isVatInclusive,
            this.vatPercent,
          )
        );
        if (item.area && item.area.name && item.area.name != "-") {
          name.push(item.area.name);
        }
      }
      this.areaName = [...new Set(name)].sort().join(",") || "-"
    } else {
      this.items.push(
        new DocumentItem(
          {},
          this.isVatInclusive,
          this.vatPercent,
        )
      );
    }
    // this.items = props.items.map(item => new DocumentItem(item, this.isVatInclusive, this.vatPercent))
  }

  static async getCreditNote(postData) {
    const { data } = await CreditNoteAPI.getCreditNote(postData)
    return new CreditNote(data.result);
  }

  static async getCreditNotes(postData) {
    const { data } = await CreditNoteAPI.getCreditNotes(postData)
    return data.result.map(cn => new CreditNote(cn));
  }

  static async getCreditNotesBetweenDateByMarket(postData) {
    const { data } = await CreditNoteAPI.getCreditNotesBetweenDateByMarket(postData)
    return postData.isRaw ? data.result : data.result.map(cn => new CreditNote(cn));
  }

  static async getCreditNotesBetweenDateByProject(postData) {
    const { data } = await CreditNoteAPI.getCreditNotesBetweenDateByProject(postData)
    return data.result.map(cn => new CreditNote(cn));
  }

  static async createCreditNote(postData) {
    const { data } = await CreditNoteAPI.createCreditNote(postData);
    return new CreditNote(data.result);
  }

  static async updateCreditNote(postData) {
    const { data } = await CreditNoteAPI.updateCreditNote(postData);
    return new CreditNote(data.result);
  }

  static async sendCreditNote({ id, date, dueDate }) {
    const { data } = await CreditNoteAPI.sendCreditNote({ id, date, dueDate });
    return new CreditNote(data.result);
  }

  static async unsendCreditNote(postData) {
    const { data } = await CreditNoteAPI.unsendCreditNote(postData);
    return new CreditNote(data.result);
  }

  static async getCreditNoteData(postData) {
    const { data } = await CreditNoteAPI.getCreditNoteData(postData);
    return {
      creditNote: new CreditNote(data.result.creditNote),
      data: data.result.data
    }
  }

  get totalOriginalValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0)
    );
  }

  get totalVatValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalVatValue || 0), 0)
    );
  }

  get totalValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalValue || 0), 0)
    );
  }

  get totalNonVatValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalVatItemsValue() {
    return Helper.round(
      this.items
        .filter(d => {
          return d.sellVatType == 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalNonVatItemsValue() {
    return Helper.round(
      this.items
        .filter(d => {
          return d.sellVatType != 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalWhtValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalWhtValue || 0), 0)
    );
  }

  get totalUnpaidValue() {
    if (this.isSent) return Helper.round(this.totalValue - this.totalPaidValue);
    else return 0;
  }

  get totalDiscountValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalDiscountValue || 0), 0)
    );
  }

  get createdByFullName() {
    if (this.createdBy)
      return `${this.createdBy.firstName || ""} ${this.createdBy.lastName || ""}`;
    else
      return "";
  }

  get status() {
    if (this.isPaid) {
      return "คืนเงินแล้ว";
    } else if (this.documentId && !this.isPaid) {
      return "ยกเลิกการคืนเงิน";
    } else {
      return "รอคืนเงิน"
    }
  }

  get oldTotalOriginalValue() {
    return Helper.round(
      this.contractCheckOutInvoice ? this.contractCheckOutInvoice.items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0) : 0
    );
  }

  get oldTotalVatValue() {
    return Helper.round(
      this.contractCheckOutInvoice ? this.contractCheckOutInvoice.items.reduce((a, b) => a + (b.totalVatValue || 0), 0) : 0
    );
  }

  get oldTotalValue() {
    return Helper.round(
      this.contractCheckOutInvoice ? this.contractCheckOutInvoice.items.reduce((a, b) => a + (b.totalValue || 0), 0) : 0
    );
  }

  get oldTotalNonVatValue() {
    return Helper.round(
      this.contractCheckOutInvoice ? this.contractCheckOutInvoice.items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0):0
    );
  }

  get oldTotalVatItemsValue() {
    return Helper.round(
      this.contractCheckOutInvoice ?
      this.contractCheckOutInvoice.items
        .filter(d => {
          return d.sellVatType == 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0) : 0
    );
  }

  get oldTotalNonVatItemsValue() {
    return Helper.round(
      this.contractCheckOutInvoice ?
      this.contractCheckOutInvoice.items.filter(d => { return d.sellVatType != 1; }).reduce((a, b) => a + (b.totalNonVatValue || 0), 0) : 0
    );
  }

  get oldTotalWhtValue() {
    return Helper.round(
      this.contractCheckOutInvoice ? this.contractCheckOutInvoice.items.reduce((a, b) => a + (b.totalWhtValue || 0), 0) : 0
    );
  }

  get oldTotalDiscountValue() {
    return Helper.round(
      this.contractCheckOutInvoice ? this.contractCheckOutInvoice.items.reduce((a, b) => a + (b.totalDiscountValue || 0), 0) : 0
    );
  }

  get diffTotalOriginalValue() {
    return Helper.round(this.totalOriginalValue - this.oldTotalOriginalValue );
  }

  get diffTotalVatValue() {
    return Helper.round(this.totalVatValue - this.oldTotalVatValue );
  }

  get diffTotalValue() {
    return Helper.round(this.totalValue - this.oldTotalValue );
  }

  get diffTotalNonVatValue() {
    return Helper.round(this.totalNonVatValue - this.oldTotalNonVatValue );
  }

  get diffTotalVatItemsValue() {
    return Helper.round(this.totalVatItemsValue - this.oldTotalVatItemsValue );
  }

  get diffTotalNonVatItemsValue() {
    return Helper.round(this.totalNonVatItemsValue - this.oldTotalNonVatItemsValue );
  }

  get diffTotalWhtValue() {
    return Helper.round(this.totalWhtValue - this.oldTotalWhtValue );
  }

  get diffTotalUnpaidValue() {
    return Helper.round(this.totalUnpaidValue - this.oldTotalUnpaidValue );
  }

  get diffTotalDiscountValue() {
    return Helper.round(this.totalDiscountValue - this.oldTotalDiscountValue );
  }

  get reDiffTotalValue() {
    return Helper.round(this.oldTotalValue - this.totalValue);
  }
}
